import { View, Text, StyleSheet } from 'react-native';
import { Feather } from '@expo/vector-icons';
import { Button } from '../ui/Button';
import { useColors, ThemeColors } from '../../hooks/useColors';

interface ProductEmptyStateProps {
  title?: string;
  description?: string;
  action?: {
    label: string;
    onPress: () => void;
  };
}

export function ProductEmptyState({ 
  title = 'No Products Found',
  description = 'Try adjusting your search or filters',
  action
}: ProductEmptyStateProps) {
  const colors = useColors();
  const styles = createStyles(colors);
  return (
    <View style={styles.container}>
      <View style={styles.icon}>
        <Feather name="package" size={32} color={colors.textLight} />
      </View>
      <Text style={styles.title}>{title}</Text>
      <Text style={styles.description}>{description}</Text>
      {action && (
        <Button 
          variant="outline"
          onPress={action.onPress}
        >
          {action.label}
        </Button>
      )}
    </View>
  );
}

const createStyles = (colors: ThemeColors) => StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 16,
    gap: 12,
  },
  icon: {
    width: 64,
    height: 64,
    borderRadius: 32,
    backgroundColor: colors.backgroundSecondary,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 8,
  },
  title: {
    fontSize: 18,
    fontWeight: '600',
    color: colors.text,
    textAlign: 'center',
  },
  description: {
    fontSize: 16,
    color: colors.textLight,
    textAlign: 'center',
    marginBottom: 8,
  },
}); 